module.exports = __webpack_public_path__ + "tmp_node_modules/choices.js/public/assets/styles/.css.liquid";


//////////////////
// WEBPACK FOOTER
// ./node_modules/choices.js/public/assets/styles/base.min.css
// module id = 347
// module chunks = 0